<template>
  <div>
    <Loader
      v-if="loaderEnabled"
      v-bind:logo="loaderLogo"
    ></Loader>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="checkPermissions(['INSTALLMENT_INSERT']) ? ' ' : ''">
          <template v-slot:toolbar>
            <div class="row">
              <router-link
                to="/accounting/installments/add"
                v-if="checkPermissions(['INSTALLMENT_INSERT'])"
              >
                <button
                  v-bind:style="btnCreate"
                  type="button"
                  class="btn btn-primary font-weight-bolder btn-sm"
                >
                  <i
                    style="font-size: 1rem"
                    class="flaticon2-add-1"
                  ></i>Thêm
                  mới
                </button>
              </router-link>
            </div>
          </template>
          <template v-slot:preview>
            <SearchBar
              :initial-keyword="keyword"
              @search="onSearch"
            />

            <InstallmentTable
              :items="installments"
              :loading="onLoading"
              @edit="editItem"
              @delete="confirmDelete"
            />

            <Pagination
              :total-items="totalItems"
              :total-pages="totalPages"
              @page-change="onPageChange"
            />

            <DeleteConfirmation
              ref="deleteConfirmation"
              @confirm="handleDeleteConfirm"
            />
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { handleError } from '@/utils/common';
import KTCodePreview from '@/view/content/CodePreview.vue';
import Loader from '@/view/content/Loader.vue';
import { mapGetters } from 'vuex';

// Import components
import DeleteConfirmation from './components/DeleteConfirmation.vue';
import InstallmentTable from './components/InstallmentTable.vue';
import Pagination from './components/Pagination.vue';
import SearchBar from './components/SearchBar.vue';

// Import mixins
import { makeToastSuccess } from '../../../../utils/common';
import permissionMixin from './mixins/permissionMixin';

export default {
  components: {
    KTCodePreview,
    Loader,
    SearchBar,
    InstallmentTable,
    Pagination,
    DeleteConfirmation,
  },
  mixins: [permissionMixin],
  data() {
    return {
      installments: [],
      onLoading: false,
      btnCreate: {
        fontWeight: '600!important',
      },
      keyword: '',
      totalPages: 1,
      totalItems: 0,
      page: 1,
      itemToDelete: null,
    };
  },
  created() {
    this.fetchInstallments();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Dịch vụ trả góp', route: 'installments' },
      { title: 'Danh sách dịch vụ trả góp' },
    ]);

    this.handleRouteParams();
  },
  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },
  },
  methods: {
    handleRouteParams() {
      if (this.$route.params.createInstallmentSuccess) {
        makeToastSuccess(this.$route.params.message);
        this.$route.params.createInstallmentSuccess = false;
      }
      if (this.$route.params.updateInstallmentSuccess) {
        makeToastSuccess(this.$route.params.message);
        this.$route.params.updateInstallmentSuccess = false;
      }
    },

    editItem(item) {
      this.$router.push({
        name: 'update-installment',
        query: { id: item.id },
      });
    },

    async fetchInstallments() {
      this.onLoading = true;
      this.page = this.$route.query.page || 1;

      let params = {
        page: this.page,
        pageSize: 10,
        keyword: this.keyword,
      };

      try {
        const response = await ApiService.query('v1/installments/all', {
          params,
        });
        const items = response.data.data.data;
        this.totalPages = response.data.data.totalPages;
        this.totalItems = response.data.data.totalItems;
        this.installments = items;
      } catch (error) {
        handleError(error);
      } finally {
        this.onLoading = false;
      }
    },

    async deleteItem(item) {
      try {
        await ApiService.delete('v1/installments/' + item.id);
        makeToastSuccess('Xóa dịch vụ trả góp thành công');
        this.fetchInstallments();
      } catch (error) {
        handleError(error);
      }
    },

    confirmDelete(item) {
      this.itemToDelete = item;
      this.$refs.deleteConfirmation.showModal(item.name);
    },

    handleDeleteConfirm() {
      if (this.itemToDelete) {
        this.deleteItem(this.itemToDelete);
        this.itemToDelete = null;
      }
    },

    onSearch(newKeyword) {
      this.keyword = newKeyword;
      this.$route.query.page = 1;
      this.$router.push({
        name: 'list-installment',
      });
      this.fetchInstallments();
    },

    onPageChange() {
      this.fetchInstallments();
    },
  },
};
</script>

<style scoped>
.icon:hover {
  background-color: #90c6fc;
}

.sttClass {
  width: 20px;
}
</style>
